var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_11211)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31369 0 12 2.68629 12 6C12 9.31369 9.31369 12 6 12C2.68629 12 0 9.31369 0 6ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76141 3.23858 11 6 11C8.76141 11 11 8.76141 11 6C11 3.23858 8.76141 1 6 1Z",
    fill: "#DA5738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 4.45953C3.99914 4.48368 4.00306 4.50779 4.0117 4.53037C4.02034 4.55294 4.0335 4.57351 4.05038 4.59081C4.06726 4.60811 4.0875 4.62178 4.10986 4.63097C4.13222 4.64016 4.15622 4.64468 4.18039 4.64425H4.79734C4.90054 4.64425 4.9828 4.55974 4.99627 4.45729C5.06357 3.96672 5.40009 3.60925 5.99985 3.60925C6.51286 3.60925 6.98249 3.86576 6.98249 4.48272C6.98249 4.95759 6.70281 5.17595 6.26084 5.50799C5.75755 5.87368 5.35896 6.30069 5.38738 6.99392L5.38962 7.1562C5.39041 7.20526 5.41045 7.25205 5.44543 7.28647C5.4804 7.32089 5.52751 7.34017 5.57658 7.34017H6.18307C6.23265 7.34017 6.2802 7.32047 6.31527 7.28541C6.35033 7.25035 6.37002 7.20279 6.37002 7.15321V7.07469C6.37002 6.53775 6.57418 6.38145 7.12533 5.96341C7.58076 5.61717 8.05563 5.23279 8.05563 4.42588C8.05563 3.29591 7.1014 2.75 6.05668 2.75C5.10919 2.75 4.0712 3.19122 4.00016 4.45953ZM5.16453 8.76926C5.16453 9.16786 5.48235 9.4625 5.91983 9.4625C6.37526 9.4625 6.6886 9.16786 6.6886 8.76926C6.6886 8.35646 6.37451 8.06631 5.91908 8.06631C5.48235 8.06631 5.16453 8.35646 5.16453 8.76926Z",
    fill: "#DA5738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_11211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.bd0a1513d068e46c6584b13b445e278e.svg";
export { ForwardRef as ReactComponent };